<template>
  <div>
    <mdb-card class="mb-4 text-left">
      <mdb-card-header>
        {{ $t('common.label.activityInYourGroups')  }}
        <translate-modal v-if="translationMode" category="common" sub-category="label" name="activityInYourGroups"/>
        <span class="flush-right" v-if="!refreshing">
          <a v-on:click="refresh"><mdb-icon class="clickable" icon="sync"></mdb-icon></a>
        </span>
      </mdb-card-header>
      <mdb-card-body>
        <div v-if="feedItems.length==0 && !refreshing">Nothing to show at this time.</div>
        <div v-if="refreshing">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <error :error="error" v-if="error"/>
        <div class="mdb-feed" v-if="feedItems">
          <div class="news" v-bind:key="item.id" v-for="item in feedItems" v-if="item.display">
            <div>
              <gp-avatar :avatar="item.image" :size="50" :reputation="item.reputation" :memberId="item.memberId" container-class=""/>
            </div>
            <div class="excerpt">
              <div class="brief">
                <div class="group-label" v-if="!group">{{item.groupName}}</div>
                <div class="message-text">{{item.message}}
                  <span class="text-black-50">
                  <mdb-icon icon="clock"/>
                  {{item.agoTime}}
                  </span>
                </div>
                <div v-if="item.linkNew && showLinks">
                  <router-link :to="item.linkNew">{{item.linkText}}</router-link>
                </div>
              </div>
            </div>
            <div style="clear:both;"/>
          </div>
          <mdb-btn v-if="group && showLinks" size="sm" rounded icon="list" @click="$router.push('/group/' + group.vanityPath + '/activity')">All Activity</mdb-btn>
        </div>
      </mdb-card-body>
    </mdb-card>

  </div>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import gpAvatar from './common/Avatar'
import error from './common/Error'
import translateModal from "./common/TranslateModal";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbMask,
  mdbRow,
  mdbView
} from 'mdbvue';

export default {
    name: 'ActivityFeed',
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardImage,
      mdbCardHeader,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbBtn,
      mdbView,
      mdbMask,
      mdbCardGroup,
      mdbIcon,
      gpAvatar,
      error,
      translateModal
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      showLinks: {
        type: Boolean,
        default: false
      },
      maxRows: {
        type: Number,
        default: 10
      }
    },
    computed: {
      translationMode() {
        return this.$store.state.translationMode
      }
    },
    data() {
      return {
        feedItems: [],
        refreshing: true,
        error: null
      };
    },
    mounted() {
      this.loadFeed()
    },
    methods: {
      loadFeed: function () {
        this.refreshing = true
        this.error = null
        this.feedItems = []
        let url = "/group/activity"
        if (this.group) url += "/" + this.group.id
        let max = this.maxRows *2  //grab double requested as some may be hidden
        url += "?max=" + max
        let details = api.get(url, {}).then(
          (response) => {
            this.feedItems = []
            let added = 0
            for (let item of response.data) {
              if (item.display && added < this.maxRows) {
                this.feedItems.push(item)
                added++
              }
            }
          },
          (error) => {
            this.error = error
          }).then(() => {
          this.refreshing = false
        })
      },
      refresh: function () {
        this.loadFeed()
      },
      navTo: function (path) {
        this.$router.push({path: path})
      }
    }
  };
</script>

<style scoped>
  .group-label {
    text-transform: uppercase;
    color: rgba(0, 0, 0, .54);
    fill: rgba(0, 0, 0, .54);
    font-size: .65em;
    font-weight: 600;
  }

  .message-text {
    font-size: .9em;
    line-height: 1 !important;
  }

  .flush-right {
    position: absolute;
    right: 0;
    padding-right: 5px;
  }

  .clickable {
    cursor: pointer;
  }


</style>
